const CONSTANTS = require('../../lib/constants');
const utils = require('../../lib/utils');
const store = require('../../lib/store');

// TODO: maybe add accordions at some point

module.exports = {
	config: {
		modeDependentContainerComponent: {
			tabStrip: [
				'/',
				'base',
				'tabStrip',
				'tabStrip'
			],
			tabStripBig: [
				'/',
				'base',
				'tabStrip',
				'big',
				'tabStrip'
			]
		},
		separatorMode: 'tabStrip',
		availableSeparators: {
			initialized: false,
			type: 'availableLangCodes',
			list: []
		},
		separatorKey: 'langCode',
		addElementActionName: 'addElement',
		hideHeadContainingOneSingleElement: true
	},

	model: {},

	methods: {
		/**
		 * this function adds a relationship element to the dom according to the given parameters.
		 *
		 * @param separatorKey
		 * @param separator
		 * @returns {*}
		 */
		addElement: function(separatorKey, separator){
			separator = separator || {};

			const self = this

			// perform relationshipElement add action(s)
			switch (self.config.separatorMode) {
				case 'tabStrip':
					return self.performAndStoreAction(
						`addElement_${separatorKey}`,
						self.prepareAction(
							separator.addElementActionName || self.config.addElementActionName,
							undefined,
							{
								tabOptions: {
									icon: separator.icon,
									title: separator.title,
									subTitle: separator.subTitle,
									grantAutoFocus: false
								},
								...(separator.resourceRegister || {})
							},
							utils.simpleMerge({
								type: CONSTANTS.COMPONENT.ACTION.TYPE.TAB,
								source: {
									tabContent: {
										componentData: {
											config: {
												separatorKey: separatorKey,
											},
										}
									}
								},
								target: {
									element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
									selector: '> .content > .base_tabStrip_tabStrip'
								},
							}, separator.actionExtension || {})
						),
						true
					);
			}
		},

		addElements: function(){
			const performActions = []
			utils.forEach(this.config.availableSeparators.list, (separator, separatorKey) => {
				performActions.push(this.addElement(separatorKey, separator));
			})
			return performActions
		},

		refreshElements: function(){
			const relationContainer = (((this.actions.relationContainer || {}).source || {}).load || {}).component
			if(relationContainer && relationContainer.hasClass('base_tabStrip_tabStrip')){
				this.$.addClass('loading')
				const activeRegisterSecret = relationContainer.model.activeRegisterSecret
				relationContainer.clearTabs()
				utils.promise.resolveAll(this, this.addElements()).then(() => {
					if(activeRegisterSecret !== undefined){
						relationContainer.focusTab(activeRegisterSecret)
					}
					this.$.removeClass('loading')
				})
			}
		},
	},

	hooks: {
		include: function($element, options){
			if(!options.refresh){
				const containerComponentConfig = {
					hideHeadContainingOneSingleElement: this.config.hideHeadContainingOneSingleElement
				};

				// TODO: REWORK THIS:
				// 			i don't remember why this should be reworked
				if(this.config.separatorMode === 'tabStrip'){
					containerComponentConfig.closableTabs = false;
				}

				// add base container for this relationship if necessary
				if(this.config.modeDependentContainerComponent[this.config.separatorMode]){
					return this.performAndStoreAction(
						'relationContainer',
						this.prepareAction({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
							source: {
								load: {
									componentData: {
										component: this.config.modeDependentContainerComponent[this.config.separatorMode],
										config: containerComponentConfig
									}
								}
							},
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
								selector: '> .content',
								position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML
							}
						})
					);
				}
			}
		},

		attach: function($element, options){
			if(!options.refresh) {

				// init
				var self = this;

				// init availableSeparators if necessary
				if(!self.config.availableSeparators.initialized){
					self.config.availableSeparators.initialized = true;
					if(utils.isFunction(self.updateAvailableSeparators)){
						self.updateAvailableSeparators();
					}
					else if(utils.isCollection(self.config.availableSeparators) && self.config.availableSeparators.type != undefined){
						// take availableLangCodes from storage
						if(self.config.availableSeparators.type === 'availableLangCodes'){
							var storage = store.get(self.requestID, self.sessionID, self.serviceDomain);
							if(storage.app && storage.app.webService && storage.app.webService.config && storage.app.webService.config.availableLangCodes){
								self.config.availableSeparators.list = utils.simpleCopy(storage.app.webService.config.availableLangCodes);
							}
						}
					}
				}

				if(utils.isFunction(self.extendAvailableSeparators)){
					self.extendAvailableSeparators()
				}

				const performActions = this.addElements()

				// init right container state
				switch (self.config.separatorMode) {
					case 'tabStrip':
						utils.promise.performAll(self, performActions).then(function(context){
							self.find('base_tabStrip_tabStrip', function(tabStripComponent){
								tabStripComponent.focusTab(0);
								return 'break';
							});
						});
						break;
				}
			}
		}
	}
};
